import { Flex } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Day } from './Day';
import { serializeParams, deserializeParams } from '../utils';

export const CustomSchedule = ({
  isNew = false,
  schedule = {},
  onChange = () => {},
}) => {
  const defaultArgs = serializeParams(isNew, schedule);
  const [selected, setSelected] = useState(defaultArgs);
  const selectedArr = Object.values(selected);

  const onChangeTime = ({ id, start, end, disabled }) => {
    setSelected((curr) => {
      const currData = curr[id];
      if (disabled) {
        return { ...curr, [id]: { ...currData, disabled: true } };
      }
      if (start && end) {
        return { ...curr, [id]: { ...currData, disabled: false, start, end } };
      }
      return { ...curr, [id]: { ...currData, disabled: false } };
    });
  };

  useEffect(() => {
    onChange(deserializeParams(selected));
  }, [selected]); //eslint-disable-line

  return (
    <Flex flexDir="column">
      {selectedArr?.map((day) => (
        <Day key={day?.id} day={day} onChange={onChangeTime} />
      ))}
    </Flex>
  );
};
